let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eg5tA")).then(() => parcelRequire('8PFu0'));